import service from './service'
export default {
  getCountData ({state, commit, dispatch}, entity) {
    return new Promise((resolve, reject) => {
      service.getCountData(entity).then(({data}) => {
        commit('ADD_COUNT_OF_ENTITIES', { entity, count: data })
        resolve()
      })
      .catch(err => {
        console.log(err)
        reject()
      })
    })
  },
  getRecentEntities ({state, commit, dispatch}, entity) {
    return new Promise((resolve, reject) => {
      service.getRecentEntities(entity).then(({data}) => {
        commit('ADD_RECENT_ENTITIES', { entity, data })
        resolve()
      })
      .catch(err => {
        console.log(err)
        reject()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/stats/store/actions.js